import React from "react";
import cn from "classnames";
import styles from "./NotificationItem.module.scss";
import { Icon } from "../../Icon/Icon";
const NotificationItem = (props) => {
    const iconClassName = props.isError
        ? "disconnect-icon"
        : "check-in-object-2-icon";
    return (React.createElement("div", { "data-cy": "notification-item", className: cn(styles.notificationItem, "z-notification-layer", {
            [styles.error]: props.isError,
        }), onClick: props.onClose },
        React.createElement("div", { className: styles.icon },
            React.createElement(Icon, { className: iconClassName })),
        React.createElement("div", null,
            React.createElement("div", { "data-cy": `notification-item-title`, className: cn("typography-h3", styles.title) }, props.title),
            React.createElement("div", { "data-cy": `notification-item-description`, className: cn("typography-small", styles.description) }, props.children)),
        React.createElement("div", { className: styles.closeIcon },
            React.createElement(Icon, { className: "close-icon icon-hover" }))));
};
export default NotificationItem;
//# sourceMappingURL=NotificationItem.js.map